import { render } from "./MenuTable.vue?vue&type=template&id=d5e6be92"
import script from "./MenuTable.vue?vue&type=script&lang=js"
export * from "./MenuTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__